import { render, staticRenderFns } from "./TransactionAmount.vue?vue&type=template&id=362a7217&scoped=true&"
import script from "./TransactionAmount.vue?vue&type=script&lang=js&"
export * from "./TransactionAmount.vue?vue&type=script&lang=js&"
import style0 from "./TransactionAmount.vue?vue&type=style&index=0&id=362a7217&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362a7217",
  null
  
)

export default component.exports